namespace('arctic.views.gds');

compass.require('compass.hotel.StayRecapWidget');
compass.require('compass.hotel.EPSStayRecapWidget');
compass.require('compass.hotel.PoliciesWidget');
compass.require('compass.hotel.GDSPoliciesWidget');

compass.require('compass.demographic.PersonalInfoWidget');

compass.requireLib('compass.util.tracking');
compass.requireLib('compass.util.parse');

arctic.views.gds.compassDirectIndividualInfo = function (viewport, options) {
	// starts measuring the time it takes for the view to load
	compass.startLoad('compassDirectIndividualInfoView');

	var me = this;
	var $j = jQuery;
	var d = jQuery.dom.getContext(this);
	var _viewport = viewport;

	var _widgets = {};
	var _recapWidget;
	var _policiesWidget;
	var _paymentType = 'deposit';
	var _settings = options;
	var _meetingInfo = _settings.meetingInfo;
	var _currentReservation = {};
	var _formInvalid = false;
	var _form;
	var _iframeDialog;

	var CC_EAN_FULL_PAYMENT_HEADER = 'Full payment is required to reserve your room. The card you provide will be charged today. Review the hotel policies for additional information.';
	var EPS_NO_DEPOSIT_HEADER = 'We need a credit card to hold your room.  You will pay the hotel directly for the cost of your stay.  Review the hotel policies for additional information.';
	var EPS_DEPOSIT_HEADER = 'A deposit is required to book your room.  Your card will be charged by the hotel.  Review the hotel policies for additional information.';
	var EPS_NON_REFUNDABLE_HEADER = 'This rate is non-refundable.  Your card will be charged by the hotel shortly after completing the booking.  Review the hotel policies for additional information.';

	var _drawTermsOfService = function(){
		if (_settings.meetingInfo.privacyPolicyLink.length === 0 ) return d.span({className: 'termsOfServiceText'}, '.');
		return [
				d.span({className: 'termsOfServiceText'}, ' and our '),
				d.a({className: 'termsOfServiceLink', 'href': _settings.meetingInfo.privacyPolicyLink, 'target': '_blank'}, 'terms of service.')
		];
	};

	var _render = function () {
		_form = d.form({ className: 'forms' },
					d.div({ className : 'personalInfoHeader'},
						d.div({ className : 'personalInfoTitle'}, 'Contact Details')
					),
					d.div({ className : 'personalInfoMain' }),
					d.div({ className : 'passwordsMain' }),
					d.div({ className : 'paymentHeader' },
						d.div({ className : 'paymentTitle'}, _settings.affiliate === 'EAN' ? 'Payment' : 'Payment Guarantee')
					),
					d.div({ className : 'creditCardTitle demographicTitle' }),
					d.div({ className : 'creditCardMain' }),
					d.div({ className : 'endPaymentInfo' }),
					d.div({className : 'policiesAgreeDiv'},
						d.input({className : 'policiesCheckbox',
							name: 'policiesCheckbox',
							'data-parsley-required': 'true',
							type: 'checkbox',
							value:'true'}),
						d.div({className :'policiesTextDiv'}, 'By placing your booking with us, you agree to the '),
						d.a({ className:'policiesLink'}, 'hotel policies'),
						d.div({ className : 'clear'}),
						_drawTermsOfService(),
						d.div({className: 'clear'})
					),
					d.button({ className : 'finishButton button', role : 'button' }, 'Finish')
				);
				
			
		_form.on('submit', function (evt) {
			evt.preventDefault();
			evt.stopPropagation();
			_submit();
			// sendInfo();
		});

		_viewport.append(d.div({ className : 'personalInfo' },
			d.div({ className : 'individualFormsContainer'},
				d.div({ className : 'IndividualFormsWidget'},
					_form
				)
			),
			d.div({ className : 'stayRecapMain' }),
			d.div({ className : 'clear' })
		));
	};

	var _setup = function (data) {
		_currentReservation = data.reservations[0];

		var _isHotelCollect = _currentReservation.summary.merchant_of_record === "property";
		var _refundable = _currentReservation.summary.refundable === true;
		var _requiresDeposit = _currentReservation.summary.depositRequired === true;
		var _chargeToday = _paymentType === 'charge';
		var paymentHeader = '';

		// select correct payment header based on reservation status (affiliate, merchant of record, deposit status, refundability)
		if (_isHotelCollect) {
			if (!_refundable) { paymentHeader = EPS_NON_REFUNDABLE_HEADER;
			} else {
				_requiresDeposit ? paymentHeader = EPS_DEPOSIT_HEADER : paymentHeader = EPS_NO_DEPOSIT_HEADER;
			}
		} else {
			paymentHeader = CC_EAN_FULL_PAYMENT_HEADER;
		}

		var paymentHeaderNode = document.createTextNode(paymentHeader);
		$j(".creditCardTitle").append(paymentHeaderNode);

		_widgets.personalInfo = new compass.demographic.PersonalInfoWidget(_viewport.find('.personalInfoMain'), {
			drawAddress: false,
			drawCompanyName : true,
			extraRequiredFields: data.extraRequiredFields,
			editablePrefill: _settings.regData,
			affiliate: _settings.affiliate,
			drawInternationalPhone: true
		});
		_widgets.password = new compass.demographic.PasswordWidget(_viewport.find('.passwordsMain'), {
		});

		_widgets.payment = new compass.demographic.PaymentWidget(_viewport.find('.creditCardMain'), {
			addressWidget: _settings.countriesAndStates,
			creditCardTypes: data.paymentOptions.payMethods,
			maskCCNumber : _.contains(data.extraRequiredFields, 'maskCreditCard'),
			minExpiration: compass.util.parse.ISODateParser(_settings.meetingInfo.ends),
			displayCVC: true,
			display2FA: true,
			displayFirstLastName: true
		});

		_recapWidget = new compass.hotel.EPSStayRecapWidget(_viewport.find('.stayRecapMain'), {
			header: {
				hotelThumbnail: data.reservations[0].summary.hotelThumbnail,
				hotelName: data.reservations[0].summary.hotelName,
				roomType: data.reservations[0].summary.roomType,
				bedType: data.reservations[0].summary.bedType,
				bedRequest: data.reservations[0].summary.bedRequest,
				avgRate: data.reservations[0].summary.avgRate
			},
			recap: data.reservations[0].summary.recap,
			meetingInfo: _settings.meetingInfo,
			depositInfo: _settings.depositInfo,
			GDS: true,
			merchantOfRecord: data.reservations[0].summary.merchant_of_record,
			processingCountry: data.processingCountry
		});
		
		//Clicking Policy Link, specifically for EPS
		var _showEPSPoliciesPopup = function (data) {
			var dateFormatter = compass.util.dateFormatter('mmmm d, yyyy');
			
			var depositPolicyDone = false;
			var hotelPolicyDone = false;

			var depositPolicySuccess = false;
			var hotelPolicySuccess = false;

			var cancelPoliciesData = [];
			var depositPoliciesData = [];
			var hotelPoliciesData = {gdsHotelPolicies: {} };
			
			var displayDepositPolicy = data.reservations[0].summary.depositRequired;

			//Assembles policy dialogue after all ajax's have completed
			var waitForAllPolicies = function() {
				if (depositPolicyDone && hotelPolicyDone) {

					if (depositPolicySuccess && hotelPolicySuccess) {

						//Gather divs and send to policies widget
						var policiesDiv = d.div({className:'policiesContainer'});
					
						//Attach extra data to the policies object 
						if (cancelPoliciesData.length > 0) {
							hotelPoliciesData.gdsHotelPolicies.cancelPolicy = cancelPoliciesData;
						}
						if (depositPoliciesData.length > 0) {
							hotelPoliciesData.gdsHotelPolicies.depositPolicy = depositPoliciesData;
						}
						hotelPoliciesData.gdsHotelPolicies.roomName = data.reservations[0].summary.roomType;
						hotelPoliciesData.gdsHotelPolicies.refundable = data.reservations[0].summary.refundable;
						
						_policiesWidget = new compass.hotel.GDSPoliciesWidget(policiesDiv, {
							WUID: 'GDS_policiesWidget_individualinfo',
							policies: hotelPoliciesData,
							affiliateHandledByOurAgent: _meetingInfo.affiliateHandledByOurAgent,
							phone: _meetingInfo.phone
						});

						_policiesDialog = d.dialog({
							classes: 'hotelInfo policiesDialog',
							contents: policiesDiv,
							centerOnView: true,
							refocus: false
						});

					} else {
						var popupParams = {
							title: 'Sorry, there was a problem',
							message: 'Please click OK to try your request again.',
							triggerName: 'stayOnPage'
						};
						var errorMessage = d.div();
						var textPopupWidget = new compass.arctic.TextPopupWidget(errorMessage, popupParams);
						var textPopupWidgetDialog = d.dialog({
							classes: 'personalInfo testDialog',
							contents: errorMessage,
							centerOnView: true,
							showCloseButton: false
						});
						textPopupWidget.bind('stayOnPage', function () {
							textPopupWidgetDialog.close();
						});
					}

				}
			};

			//Format cancel penalties into strings
			if (data.reservations[0].summary.cancelPenalties !== undefined) {
				
				var cancelPenalties = data.reservations[0].summary.cancelPenalties;
				
				var formatDate = function(dateString){
					//Expects format of yyyy-mm-ddTnn:nn:nn.nnn-NN:NN, as provided by EPS
					var dateMoment = (moment(dateString).utcOffset(dateString));
					var formattedTime = dateMoment.format("h:mm A");
					var formattedDate = dateFormatter( compass.util.parse.ISODateParser( dateMoment.format("Y-MM-DD") ) );

					return {
						date: formattedDate,
						time: formattedTime,
						srcString: dateString
					};
				};

				// If there are any non-refundable date ranges present, need to show this to the user
				var hasNonrefundableRanges = (data.reservations[0].summary.nonrefundableRanges !== undefined && data.reservations[0].summary.nonrefundableRanges.length > 0);

				// Phrasing varies on whether or not there are any actual penalties
				var hasNoPenalties = true;

				// There may be multiple penalties, but we need to track the earliest start-date of them
				var earliestStartDateObject = formatDate("9999-01-01");
				
				for (var cancelIndex = 0; cancelIndex < cancelPenalties.length; cancelIndex++){
					var cancelObject = cancelPenalties[cancelIndex];
					
					//Format the displayed time
					var formattedStartDate = formatDate(cancelObject.start);
					var cancelStartDate = formattedStartDate.date;
					var cancelStartTime = formattedStartDate.time;

					// If this penalty's start date is early than the current earliest date, replace it
					if (moment(earliestStartDateObject.srcString).isAfter(moment(formattedStartDate.srcString))) {
						earliestStartDateObject = formattedStartDate;
					}
					
					var hasAmount = (cancelObject.amount !== undefined && parseFloat(cancelObject.amount) > 0);
					var hasNights = (cancelObject.nights !== undefined && parseInt(cancelObject.nights) > 0);
					var hasPercent = (cancelObject.percent !== undefined && parseFloat(cancelObject.percent) > 0);
					
					// If the penalty amount is zero, the cancellation is free
					if (hasAmount || hasNights || hasPercent) {
						hasNoPenalties = false;
					}

					// List all penalty types present
					if (hasAmount === true) {
						cancelPoliciesData.push(
							"Cancellations made after " + cancelStartDate
							+ " at " + cancelStartTime + " (hotel's local time) will result in a "
							+ cancelObject.amount + " " + cancelObject.currency + " fee. "
						);
					}
					if (hasNights === true) {
						cancelPoliciesData.push(
							"Cancellations made after " + cancelStartDate
							+ " at " + cancelStartTime + " (hotel's local time) are subject to a "
							+ cancelObject.nights + ' night(s) penalty plus taxes and fees. '
						);
					} 
					if (hasPercent === true) {
						cancelPoliciesData.push(
							"Cancellations made after " + cancelStartDate
							+ " at " + cancelStartTime + " (hotel's local time) will result in a "
							+ cancelObject.percent + " penalty of the stay charges and fees. "
						);
					}
				}

				// Prepend different text depending on whether or not cancellation comes with penalties
				if (hasNoPenalties === true) {
					cancelPoliciesData.unshift("Free cancellation until " + earliestStartDateObject.date);
				} else {
					cancelPoliciesData.unshift(
						"Free cancellation until " + earliestStartDateObject.date
						+ " at " + earliestStartDateObject.time + " (hotel's local time). "
					);
				}

				if (hasNonrefundableRanges) {
					var nonrefundableRanges = data.reservations[0].summary.nonrefundableRanges;
					for (var rangeIndex = 0; rangeIndex < nonrefundableRanges.length; rangeIndex++) {
						var rangeObject = nonrefundableRanges[rangeIndex];
						var formattedStartDate = dateFormatter(compass.util.parse.ISODateParser(moment(rangeObject.start).format("Y-MM-DD")));
						var formattedEndDate = dateFormatter(compass.util.parse.ISODateParser(moment(rangeObject.end).format("Y-MM-DD")));
						cancelPoliciesData.push(
							"Nights booked that fall within the exception window " + formattedStartDate
							+ " to " + formattedEndDate + " provide no refund on cancellation."
						);
					}
				}

				// Append verbage that is present on all cancel penalty types (including penalty-less)
				cancelPoliciesData.push(
					"If you fail to check-in for this reservation, or if you cancel "
					+ "or change this reservation after check-in, you may incur penalty charges "
					+ "at the discretion of the property of up to 100% of the booking value."
				);
			}
			
			//Ajax for Hotel Policies
			jQuery.ajax({
				data: { hotel_id: data.reservations[0].summary.hotel_id },
				dataType:'json',
				traditional: true,
				url:'/getGDSHotelPolicies',
				success : function(data) {
					hotelPoliciesData = data;

					if (!(data.gdsHotelPolicies.error)) {
						hotelPolicySuccess = true;
					}
				},
				complete : function() {
					hotelPolicyDone = true;
					waitForAllPolicies();
				}
			});

			//Ajax for Deposit Policies 
			if (displayDepositPolicy) {
				for (var depositCount=0; depositCount < data.reservations[0].summary.deposits.length; depositCount++) {
					var depositObject = data.reservations[0].summary.deposits[depositCount];
					var depositDate = dateFormatter( compass.util.parse.ISODateParser(depositObject.due));
					var depositPrice = depositObject.value + ' ' + depositObject.currency;
					var depositLine = "You will be charged a deposit of " + depositPrice + " on " + depositDate + ' by the property.';
					depositPoliciesData.push(depositLine);
				}
				depositPolicyDone = true;
				depositPolicySuccess = true;
				waitForAllPolicies();
			} else {
				depositPolicyDone = true;
				depositPolicySuccess = true;
				waitForAllPolicies();
			}
		};
		_viewport.find('.policyLink').click(function(e) {
			e.preventDefault();
			_showEPSPoliciesPopup(data);
		});
		_viewport.find('.policiesLink').activate(function(e) {
			e.preventDefault();
			_showEPSPoliciesPopup(data);
		});

		_viewport.find(".stayRecapMain").bind('StayRecapWidget.showPolicies', function () {_showPoliciesPopup(data); });

		_viewport.find('.policiesCheckbox').change(function() {
			if ($(this).is(':checked')) {
				$('.alertCloseButton').activate();
			}
		});
		
		_iframeDialog = _create3DSIframe();
	};

	var _addValidation = function() {
		_form.parsley({
			aria: true,
			errorClass: 'invalid',
			errorsContainer: function (elem) {
				elem = elem.$element;
				var $container = elem.next();

				if ($container.hasClass('reqHint')) {
					return $container;
				}

				var $container = d.div({ className: 'reqHint' });
				$container.append(d.div({ className: 'triangle' }));

				elem.after($container);

				elem.one('focus', function (evt) {
					$container.css({ "left": (elem.outerWidth(true)-$container.outerWidth(true))/2 + elem.position().left });
				});

				return $container;
			},
			errorsWrapper: '<div class=\'text\'></div>',
			errorTemplate: '<span></span>'
		});

		_form.parsley().on('form:error', function() {
 			_formInvalid = true;
 			return;
 		});

		_form.parsley().on('field:validate', function(elem) {
			return !$(elem).is(":visible") || $(elem).hasClass('placeholder');
		});

		_form.parsley().on('field:success', function(elem) {
			if (_formInvalid) {
				if (_form.find('.invalid').length < 1) {
					_formInvalid = false;
					var button = _form.find('.finishButton');
					button.removeClass('disabled').attr('tabindex', '0');
				}
			}
		});
	};

	var _showPoliciesPopup = function (data) {
		var policiesStruct = {
			policies:{
			"depositPolicy" : data.reservations[0].GDSInfo.GDSDepositPolicy,
			"cancelPolicy" : data.reservations[0].GDSInfo.GDSCancelPolicy,
			"changesPolicy" : "",
			"specialPolicy" : "",
			"roomName" : data.reservations[0].summary.roomType,
			"hotelName" : data.reservations[0].summary.hotelName
		}};

		var policiesDiv = d.div({className:'policiesContainer'});

		_policiesWidget = new compass.hotel.PoliciesWidget(policiesDiv, {
			policies: policiesStruct
		});

		_policiesDialog = d.dialog({
			classes: 'personalInfo policiesDialog',
			contents: policiesDiv,
			centerOnView: true,
			refocus: false
		});

	};
	
	function BookingFlowException(params) {
		this.title = params.title || 'Sorry, there was a problem';
		this.message = params.message || 'Please click OK to try your search again';
		this.navigateTo = params.navigateTo;
	}
	
	var _submit = function() {
		// Check to make sure submit isn't disabled, then disable it
		var button = _viewport.find('.finishButton');
		var data = {};
		if(button.hasClass('disabled')) { return; }
		button.addClass('disabled');
		
		// Check to make sure the policies checkbox is checked
		data.policiesCheckbox = $j('.policiesCheckbox').prop('checked');
		if(data.policiesCheckbox === false){
			_policiesAgreeDialog = d.alert('Please agree to the hotel policies before continuing');
			return;
		}
		
		// Do form validation
		_form.parsley().validate();
		if(!_form.parsley().isValid()){
			_groupMememberFormInvalid = true;
			return;
		}
		
		// Start the button spinning and a callback for stopping the spinner
		compass.loading.start(button.empty(), { color : '#FFFFFF' });
		function _stopButtonLoad() {
			compass.loading.stop();
			button.removeClass('disabled');
			button.empty().append('Finish');
		}
		
		// Build the data packet
		data.contact = _widgets.personalInfo.grabValues();
		data.payment = _widgets.payment.grabValues();
		data.password = _widgets.password.grabValues();
		data.affiliate = _settings.affiliate;
		data.traveler_handling_instructions = _settings.meetingInfo.name;
		if (_jsonData.reservations[0].summary.links.book) {
			data.epsBookingURI = _jsonData.reservations[0].summary.links.book.href;
		} else {
			data.epsPaymentSessionURI = _jsonData.reservations[0].summary.links.payment_session.href;
		}

		if(!('epsBookingURI' in data) && !('epsPaymentSessionURI' in data)) {
			var keenData = {
				data: _jsonData.reservations[0].summary.links ? _jsonData.reservations[0].summary.links : {},
				error: 'epsBookingURI and epsPaymentSessionURI is missing.'
			};
			jQuery.ajax({
				url : '/sendToKeen',
				type: 'POST',
				ignoreTimeout : true,
				data: JSON.stringify({ 'stream': 'eps_booking_error', eventData: keenData }),
				dataType: 'json',
				error: function(event) {} //If call fails, suppress
			});
		}

		var countryCode = _jsonData.countriesAndStates.countries.find(function(country) {
			return country.name.toUpperCase() === data.payment.address.country.toUpperCase();
		});
		data.payment.address.countryCode = countryCode ? countryCode.abbrv : 'US';
		data.payment.paid = _jsonData.reservations[0].summary.totalCost;
		data.payment.currency = _settings.meetingInfo.currencyCode;
		var expireYear = parseInt(data.payment.expYear);
		var expireMonth = parseInt(data.payment.expMonth) - 1;
		data.payment.expireISODate = (new Date(expireYear, expireMonth)).toISOString();
		data.handled_by_our_agent = _settings.meetingInfo.affiliateHandledByOurAgent;
		
		var connector = new PayThreeDSConnector.ThreeDSConnector("threeDsIframe", "https://static.pay.expedia.com");
		connector.setup({})
		.then(function(setupResponse) {
			if (data.epsPaymentSessionURI) {
				data.threeDs = setupResponse;
				return _createPaymentSession(data);
			} else {
				return {};
			}
		})
		.then(function(createPaymentSessionResponse) {
			data.paymentSessionId = createPaymentSessionResponse.payment_session_id;
			if (createPaymentSessionResponse.links && createPaymentSessionResponse.links.book) {
				data.epsBookingURI = createPaymentSessionResponse.links.book.href;
			}
			if (createPaymentSessionResponse.encoded_init_config) {
				return connector.initSession({
					paymentSessionId: data.paymentSessionId,
					encodedInitConfig: createPaymentSessionResponse.encoded_init_config
				})
				.then(function(initSessionResponse) {
					if (initSessionResponse.statusCode === 'SUCCESS') {
						return _bookWith2FA(data);
					} else {
						throw new BookingFlowException();
					}
				});
			} else {
				if (!("epsBookingURI" in data) || data.epsBookingURI == '') {
					var keenData = {
						data: {
							"epsPaymentSessionURI": "epsPaymentSessionURI" in data ? data.epsPaymentSessionURI : '',
							"createPaymentSessionResponse": createPaymentSessionResponse
						},
						error: 'epsBookingURI is empty or missing.'
					};
					jQuery.ajax({
						url : '/sendToKeen',
						type: 'POST',
						ignoreTimeout : true,
						data: JSON.stringify({ 'stream': 'eps_booking_error', eventData: keenData }),
						dataType: 'json',
						error: function(event) {} //If call fails, suppress
					});
					throw new BookingFlowException();
				}
				return _book(data);
			}
		})
		.then(function(createBookingResponse) { // Handle some specific errors for the book calls
			if(createBookingResponse.GDSSuccess !== true) {
				var errorText = _.template(createBookingResponse.error.errorText)({
					officeName: _settings.meetingInfo.officeName
				});
				var errorParams = {
					title: createBookingResponse.error.errorTitle,
					message: errorText
				};
				if (createBookingResponse.error.errorType !== 'invalid_input') {
					errorParams.navigateTo = 'hotelInfo/' + _settings.hotel_id;
				}
				throw new BookingFlowException(errorParams);
			}

			return createBookingResponse;
		})
		.then(function(createBookingResponse) {
			// Keen Tracking
			compass.trackEvent('ReservationCreated', {
				"iterations": _settings.iterations,
				"reservations": {
					"blocked_room_id": _currentReservation.blocked_room_id,
					"arrive": _currentReservation.arrive,
					"depart": _currentReservation.depart,
					"rooms": _currentReservation.rooms
				}
			});
			compass.GA.trackEvent('CompassDirect', 'ReservationCreated');
			$j('body').css({cursor : 'inherit'});
			
			if (createBookingResponse.encodedChallengeConfig) {
				_iframeDialog.show();
				data.itineraryId = createBookingResponse.itineraryId;
				data.completePaymentURI = createBookingResponse.completePaymentURI;
				return connector.challenge({
					paymentSessionId: data.paymentSessionId,
					encodedChallengeConfig: createBookingResponse.encodedChallengeConfig
				})
				.then(function(challengeResponse) {
					if(challengeResponse.statusCode === 'SUCCESS') {
						return _completePaymentSession(data)
						.then(function(paySessionResponse) {
							if(paySessionResponse.paymentSessionSuccess !== true) {
								var errorText = _.template(paySessionResponse.error.errorText)({
									officeName: _settings.meetingInfo.officeName
								});
								var errorParams = {
									title: paySessionResponse.error.errorTitle,
									message: errorText
								};
								errorParams.navigateTo = 'hotelInfo/' + _settings.hotel_id;
								throw new BookingFlowException(errorParams);
							}
							return paySessionResponse;
						});
					} else {
						var keenData = {
							data: {
								attendance_id: createBookingResponse.loginInfo ? createBookingResponse.loginInfo.id : 0,
								error: challengeResponse,
								itinerary_id: data.itineraryId,
							},
							error: 'Failed PSD2 OTP'
						};
						jQuery.ajax({
							url : '/sendToKeen',
							type: 'POST',
							ignoreTimeout : true,
							data: JSON.stringify({ 'stream': 'eps_booking_error', eventData: keenData }),
							dataType: 'json',
							error: function(event) {} //If call fails, suppress
						});
						throw new BookingFlowException();
					}
				})
				.finally(function() {
					_iframeDialog.hide();
				});
			} else {
				return createBookingResponse;
			}
		})
		.then(function(createBookingResponse) {
			_sendConfo();
			$j('body').trigger(CompassEvents.Login, createBookingResponse.loginInfo);
			_viewport.trigger(CompassEvents.Navigate, 'frontDesk');
		})
		.finally(function() {
			_stopButtonLoad();
		})
		.catch(function(error) {
			var finalError;
			if (error instanceof BookingFlowException) {
				finalError = error;
			} else { // Unless a specific error was thrown, show the default messages and then navigate to hotelInfo
				finalError = new BookingFlowException({
					navigateTo: 'hotelInfo/' + _settings.hotel_id
				});
			}
			var popupParams = {
				title: finalError.title,
				message: finalError.message,
				triggerName: 'bookingFlowErrorClosed'
			};
			var errorMessage = d.div();
			var textPopupWidget = new compass.arctic.TextPopupWidget(errorMessage, popupParams);
			var textPopupWidgetDialog = d.dialog({
				classes: 'compassDirectIndividualInfo errorDialog',
				contents: errorMessage,
				centerOnView: true,
				showCloseButton: false
			});
			textPopupWidget.bind('bookingFlowErrorClosed', function () {
				if (finalError.navigateTo !== undefined) {
					_viewport.trigger(CompassEvents.Navigate, finalError.navigateTo);
				} else { // This else is probably not required because of the finally above, but just in case
					textPopupWidgetDialog.close();
				}
			});
		});
	};
	
	var _create3DSIframe = function() {
		var iframe = d.div({className: 'iframe-holder'},
			d.iframe({
				id: 'threeDsIframe',
				src: _settings.expediaIframeURL,
				sandbox: 'allow-scripts allow-forms allow-same-origin'
			})
		);

		var iframeDialog = d.dialog({
			classes: '',
			contents: iframe,
			centerOnView: true,
			visible: false,
			disableClicksOutsideModal: true,
			showCloseButton: false
		});
		
		return iframeDialog;
	};
	
	var _createPaymentSession = function(data) {
		return $j.ajax({
			url: '/actEPSCreatePaymentSession',
			data : JSON.stringify(data),
			type : 'POST',
			error: function() {} // Because of the generic error handlers we use, this needs to be specified to avoid the generic error message
		})
		.then(function(createPaymentSessionResponse) {
			if (createPaymentSessionResponse.error !== undefined || createPaymentSessionResponse.type !== undefined) {
				throw 'Generic error'; // Just treat this case as an error and have it get picked up by the error handling
			}
			return createPaymentSessionResponse;
		});
	};
	
	var _bookWith2FA = function(data) {
		return $j.ajax({
			url: '/actEPSBook',
			data : JSON.stringify(data),
			type : 'POST',
			contentType : 'application/json',
			processData: false,
			error: function() {} // Because of the generic error handlers we use, this needs to be specified to avoid the generic error message
		});
	};
	
	var _book = function(data) {
		return $j.ajax({
			url: '/actEPSIndividualInfo',
			data : JSON.stringify(data),
			type : 'POST',
			contentType : 'application/json',
			processData: false,
			timeout: 90000,
			error: function() {} // Because of the generic error handlers we use, this needs to be specified to avoid the generic error message
		});
	};
	
	var _completePaymentSession = function(data) {
		return $j.ajax({
			url: '/actEPSCompletePaymentSession',
			data : JSON.stringify(data),
			type : 'POST',
			error: function() {} // Because of the generic error handlers we use, this needs to be specified to avoid the generic error message
		})
		.then(function(completePaymentSessionResponse) {
			if (completePaymentSessionResponse.type !== undefined) {
				throw 'Generic error'; // Just treat this case as an error and have it get picked up by the error handling
			}
			return completePaymentSessionResponse;
		});
	};
	
	var _sendConfo = function() {
		var estimatedTotal = _recapWidget.getEstimatedTotalValue();
		jQuery.ajax({
		url : '/sendConfirmation',
			success : function(data) {
				compass.util.tracking.exactTargetConversion();
				compass.util.tracking.googleConversion({
					value: estimatedTotal,
					currency: _settings.meetingInfo.currencyCode
				});
			},
			error: function() {} // Because of the generic error handlers we use, this needs to be specified to avoid the generic error message
		});
	};

	this.run = function (renderComplete) {
		compass.loading.start();
		$j.ajax({
			url: '/getGDSIndividualInfo',
			success: function (data) {
				_jsonData = data;

				//Prevent error on backbutton or direct link without reservation, redirects back to frontdesk/hotels
				if(data.redirect){
					_viewport.trigger(CompassEvents.Navigate, data.redirect);
					return;
				}

				_settings.iterations = data.iterations || 1;
				_settings.countriesAndStates = data.countriesAndStates;
				_settings.affiliate = data.reservations[0].summary.affiliate;
				_settings.hotel_id = data.reservations[0].summary.hotel_id;
				_settings.processingCountry = data.processingCountry;
				_settings.depositInfo = {
					'depositRequired': data.reservations[0].summary.depositRequired,
					'refundable': data.reservations[0].summary.refundable
				};
				_settings.expediaIframeURL = data.expedia.iframeURL;
				if (data.error) {
					_viewport.trigger(CompassEvents.Navigate, 'frontdesk');
				} else {
					_render();
					_setup(data);
					_addValidation();
				}
				compass.loading.stop();
				// stops measuring the time it takes the view to load
				compass.stopLoad('compassDirectIndividualInfoView');
				renderComplete();
			}
		});
	};
};